export default {
    imageDashboardSummary: {
        totalImagesGenerated: 'Totalt antal genererede billeder',
        cost: 'Omkostning',
        imagesPerDay: 'Billeder/dag',
    },
};
